import { uri } from "../constants";


export const bulkCreateClaims = async (userId, data) => {
    try {
        const response = await fetch(`${uri}/users/${userId}/claims/bulk`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
        });
        if (!response.ok) throw new Error("Failed to create claims");
        return await response.json();
    } catch (error) {
        console.error("Error creating claims:", error);
        throw error;
    }
}